<template>
  <div class="header-wrapper relative flex flex-col">
    <!-- <div class="order-1" />-->
    <div class="w-full" :class="{ 'order-1': isVideo }">
      <CraftAsset
        v-if="media"
        :ratio="12 / 5"
        :asset="media"
        :autoplay="true"
        :alt="alt"
        sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
        data-test-id="asset"
        :max-height="true"
      />
    </div>
    <div
      class="w-full lg:self-center"
      :class="[isVideo ? 'container order-0 box-white' : 'box lg:-mt-32 lg:p-24 z-10 lg:w-3/4']"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import CraftAsset from '@/components/common/CraftAsset';

export default defineNuxtComponent({
  name: 'StoryHeader',
  components: {
    CraftAsset,
  },
  props: {
    asset: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: null,
    },
  },
  computed: {
    isVideo() {
      return this.media.kind !== 'image';
    },
    media() {
      return this.asset.length && this.asset[0];
    },
  },
});
</script>
